import script from "./DonationOfferingChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationOfferingChart.vue?vue&type=script&setup=true&lang=js"

import "./DonationOfferingChart.vue?vue&type=style&index=0&id=68617b94&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68617b94"]])

export default __exports__